<template>
  <form action="/api/checkout-sponsor" method="POST" @submit="handleSubmit">
    <input type="hidden" name="quotation_id" :value="quotationId" />
    <div class="promo-data mb-30">
      <p class="mb-30">Data di scadenza della tua assicurazione</p>
    </div>
    <div class="d-flex mb-30">
      <custom-select name="giorno" :options="giorniOptions" placeholder="Giorno" v-model="selectedGiorno"
        :isOpen="openDropdown === 0" @toggle="handleToggle(0)"></custom-select>
      <custom-select name="mese" :options="mesiOptions" placeholder="Mese" v-model="selectedMese"
        :isOpen="openDropdown === 1" @toggle="handleToggle(1)"></custom-select>
      <custom-select name="anno" :options="anniOptions" placeholder="Anno" v-model="selectedAnno"
        :isOpen="openDropdown === 2" @toggle="handleToggle(2)"></custom-select>
    </div>
    <p class="promo-data mb-30">Cellulare</p>
    <div class="input_container phone-container">
      <input id="cellulare" type="text" name="cellulare" placeholder="3331234567" class="no-spinners phone"
        style="padding: 10px" />
    </div>
    <div class="promo-privacy mb-30">
      <p>
        Ti informiamo che, con il tuo consenso, liberamente prestato, i tuoi Dati personali verranno
        trasferiti da Editoriale Domus S.p.A. a Generali Italia S.p.A., che sponsorizza il servizio
        di Quotazioni e che li tratterà in qualità di autonomo titolare del trattamento per finalità
        di marketing. <br /><br />
        In caso di rilascio del consenso, i tuoi dati verranno utilizzati da Generali Italia S.p.A.
        per proporti servizi e offerte commerciali (es. offerte speciali, inviti a eventi).
        <br /><br />
        Potrai conoscere quali sono i tuoi dati trattati presso Generali Italia S.p.A. e, ove ne
        ricorrano le condizioni, esercitare i diversi diritti relativi al loro utilizzo (diritto di
        accesso, rettifica, aggiornamento, integrazione, cancellazione, limitazione al trattamento,
        alla portabilità, alla revoca del consenso al trattamento e di ottenere una copia dei propri
        dati laddove questi siano conservati in paesi al di fuori dell’Unione Europea, nonché di
        ottenere indicazione del luogo nel quale tali dati vengono conservati o trasferiti) nonché
        opporsi per motivi legittimi ad un loro particolare trattamento e comunque al loro uso a
        fini commerciali, in tutto o in parte anche per quanto riguarda l’uso di modalità
        automatizzate rivolgendoti a: Generali Italia S.p.A., Via Marocchesa 14, 31021 Mogliano
        Veneto TV, privacy.it@generali.com o al Responsabile della Protezione dei Dati (RPD),
        contattabile via e-mail a “RPD.it@generali.com” e/o via posta ordinaria all’indirizzo “RPD
        Generali Italia - Mogliano Veneto, Via Marocchesa 14 31021. Ti informiamo, inoltre, che,
        qualora ravvisassi un trattamento dei tuoi dati non coerente con i consensi espressi puoi
        sporgere reclamo al Garante per la protezione dei dati personali, con le modalità indicate
        sul sito del Garante stesso. <br /><br />
        Puoi prendere visione dell’Informativa completa di Generali Italia S.p.A. cliccando qui.
        <br /><br />
        Ti chiediamo quindi di selezionare la casella "Acconsento", laddove intendi consentire a
        Editoriale Domus S.p.A., Titolare del trattamento, di trasmettere i tuoi dati a Generali
        Italia S.p.A., affinché possa svolgere nei tuoi confronti attività di marketing diretto,
        come da informativa sopra indicata:
      </p>
    </div>
    <div class="consent">
      <div class="input_container radio_container mb-30">
        <label class="input-radio">
          <span>Acconsento</span>
          <input type="radio" id="consent-yes" name="consent" value="1" />
          <span class="checkmark"></span>
        </label>
        <label class="input-radio">
          <span>Non acconsento</span>
          <input type="radio" id="consent-none" name="consent" value="0" />
          <span class="checkmark"></span>
        </label>
        <input type="radio" id="consent-null" name="consent" value="null" hidden checked>
      </div>
      <button class="button-primary" type="submit" :disabled="!isFormValid || loading">
        <template v-if="!loading"><span>Ottieni quotazione</span></template>
        <loader v-else size="20px" />
      </button>
    </div>
  </form>
</template>

<script>
import Loader from './Loader.vue';
import CustomSelect from './CustomSelect.vue';

export default {
  name: 'BuySponsoredForm',
  components: {
    Loader,
    CustomSelect,
  },
  props: {
    quotationId: {
      type: Number,
      required: true,
    },
    anni: {
      type: Object,
      required: true,
    },
    mesi: {
      type: Object,
      required: true,
    },
    giorni: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      openDropdown: null,
      selectedAnno: '',
      selectedMese: '',
      selectedGiorno: '',
    };
  },
  computed: {
    infobike() {
      return this.data.infobike;
    },
    anniOptions() {
      return Object.keys(this.anni)
        .sort((a, b) => a - b)
        .map(key => ({
          value: key.toString(),
          text: this.anni[key],
        }));
    },
    mesiOptions() {
      return Object.keys(this.mesi)
        .sort((a, b) => a - b)
        .map(key => ({
          value: key.toString(),
          text: this.mesi[key],
        }));
    },
    giorniOptions() {
      return this.giorni.map(giorno => ({
        value: giorno.toString(),
        text: giorno.toString().padStart(2, '0'),
      }));
    },
    isFormValid() {
      return this.selectedGiorno && this.selectedMese && this.selectedAnno;
    },
  },
  methods: {
    handleSubmit() {
      this.loading = true;
    },
    handleToggle(index) {
      if (this.openDropdown === index) {
        this.openDropdown = null;
      } else {
        this.openDropdown = index;
      }
    },
  },
};
</script>

<style scoped>
.button-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.d-flex {
  display: flex;
  justify-content: center;
  gap: 20px;

  @media screen and (max-width:768px) {
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }
}

.phone-container {
  @media screen and (max-width:768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 40px;
  }
}

.phone {
  margin: 0 0 20px 20px;

  @media screen and (max-width:768px) {
    margin: 0 0 20px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/BuySponsoredForm.vue